module.exports = __webpack_public_path__ + "static/postgresql-3dda7835a7ff0f160940a73a0c24c921.png";